/**
 * Our Redux actions -- these are the types (think of it as a label) that uniquely ID the types of actions we perform
 * in the app.
 */

export enum ACTION_TYPE {
  CLEAR_API_ERROR                = 'CLEAR_API_ERROR',

  SELECTED_RESORT               = 'SELECTED_RESORT',

  APPLIANCE_VERSION_REQUEST      = 'APPLIANCE_VERSION_REQUEST',
  APPLIANCE_VERSION_RESPONSE     = 'APPLIANCE_VERSION_RESPONSE',
  APPLIANCE_VERSION_ERROR        = 'APPLIANCE_VERSION_ERROR',

  UPDATE_RELEASE_NOTES_REQUEST   = 'UPDATE_RELEASE_NOTES_REQUEST',
  UPDATE_RELEASE_NOTES_RESPONSE  = 'UPDATE_RELEASE_NOTES_RESPONSE',
  UPDATE_RELEASE_NOTES_ERROR     = 'UPDATE_RELEASE_NOTES_ERROR',

  DEFAULT_CONFIG                 = 'DEFAULT_CONFIG',

  APP_CONFIG_REQUEST             = 'APP_CONFIG_REQUEST',
  APP_CONFIG_RESPONSE            = 'APP_CONFIG_RESPONSE',
  APP_CONFIG_ERROR               = 'APP_CONFIG_ERROR',

  SCRIPT_VERSION_REQUEST         = 'SCRIPT_VERSION_REQUEST',
  SCRIPT_VERSION_RESPONSE        = 'SCRIPT_VERSION_RESPONSE',
  SCRIPT_VERSION_ERROR           = 'SCRIPT_VERSION_ERROR',

  SET_LOCALE                     = 'SET_LOCALE',
  SET_DATE_FORMAT                = 'SET_DATE_FORMAT',

  RESORT_DETAILS_REQUEST         = 'RESORT_DETAILS_REQUEST',
  RESORT_DETAILS_RESPONSE        = 'RESORT_DETAILS_RESPONSE',
  RESORT_DETAILS_ERROR           = 'RESORT_DETAILS_ERROR',

  LOGIN_REQUEST                  = 'LOGIN_REQUEST',
  LOGIN_RESPONSE                 = 'LOGIN_RESPONSE',
  LOGIN_ERROR                    = 'LOGIN_ERROR',
  LOGOUT                         = 'LOGOUT',
  CLEAR_RESET_PASSWORD           = 'CLEAR_RESET_PASSWORD',

  SHOW_SNACKBAR                  = 'SHOW_SNACKBAR',
  HIDE_SNACKBAR                  = 'HIDE_SNACKBAR',

  DISMISS_MODAL                  = 'DISMISS_MODAL',
  SHOW_MODAL                     = 'SHOW_MODAL',

  SET_COPY_TO_CLIPBOARD          = 'SET_COPY_TO_CLIPBOARD',
  CLEAR_COPY_TO_CLIPBOARD        = 'CLEAR_COPY_TO_CLIPBOARD',

  GUEST_SEARCH_REQUEST           = 'GUEST_SEARCH_REQUEST',
  GUEST_SEARCH_RESPONSE          = 'GUEST_SEARCH_RESPONSE',
  GUEST_SEARCH_ERROR             = 'GUEST_SEARCH_ERROR',

  SEARCH_HISTORY_REQUEST         = 'SEARCH_HISTORY_REQUEST',
  SEARCH_HISTORY_RESPONSE        = 'SEARCH_HISTORY_RESPONSE',
  SEARCH_HISTORY_ERROR           = 'SEARCH_HISTORY_ERROR',

  CLEAR_SEARCH_HISTORY_REQUEST   = 'CLEAR_SEARCH_HISTORY_REQUEST',
  CLEAR_SEARCH_HISTORY_RESPONSE  = 'CLEAR_SEARCH_HISTORY_RESPONSE',
  CLEAR_SEARCH_HISTORY_ERROR     = 'CLEAR_SEARCH_HISTORY_ERROR',

  HOUSEHOLD_REQUEST              = 'HOUSEHOLD_REQUEST',
  HOUSEHOLD_RESPONSE             = 'HOUSEHOLD_RESPONSE',
  HOUSEHOLD_ERROR                = 'HOUSEHOLD_ERROR',

  GUEST_DETAILS_REQUEST          = 'GUEST_DETAILS_REQUEST',
  GUEST_DETAILS_RESPONSE         = 'GUEST_DETAILS_RESPONSE',
  GUEST_DETAILS_ERROR            = 'GUEST_DETAILS_ERROR',

  SET_GUEST_PHOTO_REQUEST        = 'SET_GUEST_PHOTO_REQUEST',
  SET_GUEST_PHOTO_RESPONSE       = 'SET_GUEST_PHOTO_RESPONSE',
  SET_GUEST_PHOTO_ERROR          = 'SET_GUEST_PHOTO_ERROR',

  GET_GUEST_PHOTO_REQUEST        = 'GET_GUEST_PHOTO_REQUEST',
  GET_GUEST_PHOTO_RESPONSE       = 'GET_GUEST_PHOTO_RESPONSE',
  GET_GUEST_PHOTO_ERROR          = 'GET_GUEST_PHOTO_ERROR',

  ASSOC_RFID_REQUEST             = 'ASSOC_RFID_REQUEST',
  ASSOC_RFID_RESPONSE            = 'ASSOC_RFID_RESPONSE',
  ASSOC_RFID_ERROR               = 'ASSOC_RFID_ERROR',

  SUBMIT_WAIVER_REQUEST          = 'SUBMIT_WAIVER_REQUEST',
  SUBMIT_WAIVER_RESPONSE         = 'SUBMIT_WAIVER_RESPONSE',
  SUBMIT_WAIVER_ERROR            = 'SUBMIT_WAIVER_ERROR',

  GET_WAIVER_LOOKUP_REQUEST      = 'GET_WAIVER_LOOKUP_REQUEST',
  GET_WAIVER_LOOKUP_RESPONSE     = 'GET_WAIVER_LOOKUP_RESPONSE',
  GET_WAIVER_LOOKUP_ERROR        = 'GET_WAIVER_LOOKUP_ERROR',

  IMPORT_GUEST_REQUEST           = 'IMPORT_GUEST_REQUEST',
  IMPORT_GUEST_RESPONSE          = 'IMPORT_GUEST_RESPONSE',
  IMPORT_GUEST_ERROR             = 'IMPORT_GUEST_ERROR',

  MEDIA_HISTORY_REQUEST          = 'MEDIA_HISTORY_REQUEST',
  MEDIA_HISTORY_RESPONSE         = 'MEDIA_HISTORY_RESPONSE',
  MEDIA_HISTORY_ERROR            = 'MEDIA_HISTORY_ERROR',

  VALID_LIFT_ACCESS_LOCATIONS_REQUEST   = 'VALID_LIFT_ACCESS_LOCATIONS_REQUEST',
  VALID_LIFT_ACCESS_LOCATIONS_RESPONSE  = 'VALID_LIFT_ACCESS_LOCATIONS_RESPONSE',
  VALID_LIFT_ACCESS_LOCATIONS_ERROR     = 'VALID_LIFT_ACCESS_LOCATIONS_ERROR',

  DISABLE_GUEST_MEDIA_REQUEST    = 'DISABLE_GUEST_MEDIA_REQUEST',
  DISABLE_GUEST_MEDIA_RESPONSE   = 'DISABLE_GUEST_MEDIA_RESPONSE',
  DISABLE_GUEST_MEDIA_ERROR      = 'DISABLE_GUEST_MEDIA_ERROR',

  ENABLE_GUEST_MEDIA_REQUEST    = 'ENABLE_GUEST_MEDIA_REQUEST',
  ENABLE_GUEST_MEDIA_RESPONSE   = 'ENABLE_GUEST_MEDIA_RESPONSE',
  ENABLE_GUEST_MEDIA_ERROR      = 'ENABLE_GUEST_MEDIA_ERROR',

  // ---- Payment Methods and Guest Payment Registraitons --------------------------------------------------------------

  GET_GUEST_PAYMENT_REGISTRATION_REQUEST        = 'GET_GUEST_PAYMENT_REGISTRATION_REQUEST',
  GET_GUEST_PAYMENT_REGISTRATION_RESPONSE       = 'GET_GUEST_PAYMENT_REGISTRATION_RESPONSE',
  GET_GUEST_PAYMENT_REGISTRATION_ERROR          = 'GET_GUEST_PAYMENT_REGISTRATION_ERROR',

  DEACTIVATE_GUEST_PAYMENT_REGISTRATION_REQUEST        = 'DEACTIVATE_GUEST_PAYMENT_REGISTRATION_REQUEST',
  DEACTIVATE_GUEST_PAYMENT_REGISTRATION_RESPONSE       = 'DEACTIVATE_GUEST_PAYMENT_REGISTRATION_RESPONSE',
  DEACTIVATE_GUEST_PAYMENT_REGISTRATION_ERROR          = 'DEACTIVATE_GUEST_PAYMENT_REGISTRATION_ERROR',

  GET_PAYMENT_METHOD_REQUEST        = 'GET_PAYMENT_METHOD_REQUEST',
  GET_PAYMENT_METHOD_RESPONSE       = 'GET_PAYMENT_METHOD_RESPONSE',
  GET_PAYMENT_METHOD_ERROR          = 'GET_PAYMENT_METHOD_ERROR',

  GET_PAYMENT_GUEST_REQUEST        = 'GET_PAYMENT_GUEST_REQUEST',
  GET_PAYMENT_GUEST_RESPONSE       = 'GET_PAYMENT_GUEST_RESPONSE',
  GET_PAYMENT_GUEST_ERROR          = 'GET_PAYMENT_GUEST_ERROR',

  CLEAR_PAYMENT_METHOD              = 'CLEAR_PAYMENT_METHOD',

  // ---- Pass Printing ------------------------------------------------------------------------------------------------

  REISSUE_MEDIA_REQUEST          = 'REISSUE_MEDIA_REQUEST',
  REISSUE_MEDIA_RESPONSE         = 'REISSUE_MEDIA_RESPONSE',
  REISSUE_MEDIA_ERROR            = 'REISSUE_MEDIA_ERROR',

  MARK_GUEST_PDF_PRINTED         = 'MARK_GUEST_PDF_PRINTED',

  GET_SEASON_REPRINT_COUNT_REQUEST  = 'GET_SEASON_REISSUE_COUNT_REQUEST',
  GET_SEASON_REPRINT_COUNT_RESPONSE = 'GET_SEASON_REISSUE_COUNT_RESPONSE',
  GET_SEASON_REPRINT_COUNT_ERROR    = 'GET_SEASON_REISSUE_COUNT_ERROR',
  
  // ---- Guest Comments -----------------------------------------------------------------------------------------------

  GUEST_COMMENTS_REQUEST         = 'GUEST_COMMENTS_REQUEST',
  GUEST_COMMENTS_RESPONSE        = 'GUEST_COMMENTS_RESPONSE',
  GUEST_COMMENTS_ERROR           = 'GUEST_COMMENTS_ERROR',

  GET_HAS_COMMENTS_REQUEST       = 'GET_HAS_COMMENTS_REQUEST',
  GET_HAS_COMMENTS_RESPONSE      = 'GET_HAS_COMMENTS_RESPONSE',
  GET_HAS_COMMENTS_ERROR         = 'GET_HAS_COMMENTS_ERROR',

  ADD_GUEST_COMMENT_REQUEST      = 'ADD_GUEST_COMMENT_REQUEST',
  ADD_GUEST_COMMENT_RESPONSE     = 'ADD_GUEST_COMMENT_RESPONSE',
  ADD_GUEST_COMMENT_ERROR        = 'ADD_GUEST_COMMENT_ERROR',

  SUBMIT_GUEST_COMMENTS_REQUEST  = 'SUBMIT_GUEST_COMMENTS_REQUEST',
  SUBMIT_GUEST_COMMENTS_RESPONSE = 'SUBMIT_GUEST_COMMENTS_REQUEST',
  SUBMIT_GUEST_COMMENTS_ERROR    = 'SUBMIT_GUEST_COMMENTS_REQUEST',

  // ---- Entitlements -------------------------------------------------------------------------------------------------

  GUEST_ENTITLEMENTS_REQUEST     = 'GUEST_ENTITLEMENTS_REQUEST',
  GUEST_ENTITLEMENTS_RESPONSE    = 'GUEST_ENTITLEMENTS_RESPONSE',
  GUEST_ENTITLEMENTS_ERROR       = 'GUEST_ENTITLEMENTS_ERROR',

  GET_ALL_ENTITLEMENT_TYPES_REQUEST  = 'GET_ALL_ENTITLEMENT_TYPES_REQUEST',
  GET_ALL_ENTITLEMENT_TYPES_RESPONSE = 'GET_ALL_ENTITLEMENT_TYPES_RESPONSE',
  GET_ALL_ENTITLEMENT_TYPES_ERROR    = 'GET_ALL_ENTITLEMENT_TYPES_ERROR',

  GET_DTW_ENTITLEMENTS_REQUEST   = 'GET_DTW_ENTITLEMENTS_REQUEST',
  GET_DTW_ENTITLEMENTS_RESPONSE  = 'GET_DTW_ENTITLEMENTS_RESPONSE',
  GET_DTW_ENTITLEMENTS_ERROR     = 'GET_DTW_ENTITLEMENTS_ERROR',

  GET_FNF_ENTITLEMENTS_REQUEST   = 'GET_FNF_ENTITLEMENTS_REQUEST',
  GET_FNF_ENTITLEMENTS_RESPONSE  = 'GET_FNF_ENTITLEMENTS_RESPONSE',
  GET_FNF_ENTITLEMENTS_ERROR     = 'GET_FNF_ENTITLEMENTS_ERROR',

  GET_FNF_BLACKOUTDATE_METADATA_REQUEST   = 'GET_FNF_BLACKOUTDATE_METADATA_REQUEST ',
  GET_FNF_BLACKOUTDATE_METADATA_RESPONSE  = 'GET_FNF_BLACKOUTDATE_METADATA_RESPONSE',
  GET_FNF_BLACKOUTDATE_METADATA_ERROR     = 'GET_FNF_BLACKOUTDATE_METADATA_ERROR',

  GET_LIFT_BLACKOUTDATE_METADATA_REQUEST   = 'GET_LIFT_BLACKOUTDATE_METADATA_REQUEST ',
  GET_LIFT_BLACKOUTDATE_METADATA_RESPONSE  = 'GET_LIFT_BLACKOUTDATE_METADATA_RESPONSE',
  GET_LIFT_BLACKOUTDATE_METADATA_ERROR     = 'GET_LIFT_BLACKOUTDATE_METADATA_ERROR',

  REDEEM_ENTITLEMENT_REQUEST     = 'REDEEM_ENTITLEMENT_REQUEST',
  REDEEM_ENTITLEMENT_RESPONSE    = 'REDEEM_ENTITLEMENT_RESPONSE',
  REDEEM_ENTITLEMENT_ERROR       = 'REDEEM_ENTITLEMENT_ERROR',
  CLEAR_REDEEMED_ENTITLEMENT     = 'CLEAR_REDEEMED_ENTITLEMENT',

  BULK_CORRECTION_REQUEST        = 'BULK_CORRECTION_REQUEST',
  BULK_CORRECTION_RESPONSE       = 'BULK_CORRECTION_RESPONSE',
  BULK_CORRECTION_ERROR          = 'BULK_CORRECTION_ERROR',

  MIGRATE_REDEMPTIONS_REQUEST    = 'MIGRATE_REDEMPTIONS_REQUEST',
  MIGRATE_REDEMPTIONS_RESPONSE   = 'MIGRATE_REDEMPTIONS_RESPONSE',
  MIGRATE_REDEMPTIONS_ERROR      = 'MIGRATE_REDEMPTIONS_ERROR',

  GET_ALL_REDEMPTION_TYPES_REQUEST  = 'GET_ALL_REDEMPTION_TYPES_REQUEST',
  GET_ALL_REDEMPTION_TYPES_RESPONSE = 'GET_ALL_REDEMPTION_TYPES_RESPONSE',
  GET_ALL_REDEMPTION_TYPES_ERROR    = 'GET_ALL_REDEMPTION_TYPES_ERROR',

  SUBMIT_LOCAL_REF_REQUEST       = 'SUBMIT_LOCAL_REF_REQUEST',
  SUBMIT_LOCAL_REF_RESPONSE      = 'SUBMIT_LOCAL_REF_RESPONSE',
  SUBMIT_LOCAL_REF_ERROR         = 'SUBMIT_LOCAL_REF_ERROR',

  PASS_RESORTS_REQUEST           = 'PASS_RESORTS_REQUEST',
  PASS_RESORTS_RESPONSE          = 'PASS_RESORTS_RESPONSE',
  PASS_RESORTS_ERROR             = 'PASS_RESORTS_ERROR',

  RESORT_HISTORY_REQUEST         = 'RESORT_HISTORY_REQUEST',
  RESORT_HISTORY_RESPONSE        = 'RESORT_HISTORY_RESPONSE',
  RESORT_HISTORY_ERROR           = 'RESORT_HISTORY_ERROR',
  CLEAR_RESORTS_HISTORY          = 'CLEAR_RESORTS_HISTORY',

// Entitlement Type Metadata (Validation Configuration Tool)
  GET_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_REQUEST  = 'GET_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_REQUEST',
  GET_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_RESPONSE = 'GET_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_RESPONSE',
  GET_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_ERROR    = 'GET_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_ERROR',

  GET_EFFECTIVE_DATE_RANGE_RULE_HISTORY_REQUEST  = 'GET_EFFECTIVE_DATE_RANGE_RULE_HISTORY_REQUEST',
  GET_EFFECTIVE_DATE_RANGE_RULE_HISTORY_RESPONSE = 'GET_EFFECTIVE_DATE_RANGE_RULE_HISTORY_RESPONSE',
  GET_EFFECTIVE_DATE_RANGE_RULE_HISTORY_ERROR    = 'GET_EFFECTIVE_DATE_RANGE_RULE_HISTORY_ERROR',

  UPDATE_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_REQUEST  = 'UPDATE_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_REQUEST',
  UPDATE_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_RESPONSE = 'UPDATE_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_RESPONSE',
  UPDATE_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_ERROR    = 'UPDATE_EDITABLE_EFFECTIVE_DATE_RANGE_ACCESS_RULES_ERROR',

// Product Administration Tool

  GET_SELLING_SEASONS_REQUEST  = 'GET_SELLING_SEASONS_REQUEST',
  GET_SELLING_SEASONS_RESPONSE = 'GET_SELLING_SEASONS_RESPONSE',
  GET_SELLING_SEASONS_ERROR    = 'GET_SELLING_SEASONS_ERROR',

  GET_FULFILLMENT_SEASONS_REQUEST  = 'GET_FULFILLMENT_SEASONS_REQUEST',
  GET_FULFILLMENT_SEASONS_RESPONSE = 'GET_FULFILLMENT_SEASONS_RESPONSE',
  GET_FULFILLMENT_SEASONS_ERROR    = 'GET_FULFILLMENT_SEASONS_ERROR',

  SEARCH_LIFT_ACCESS_RULES_REQUEST  = 'SEARCH_LIFT_ACCESS_RULES_REQUEST',
  SEARCH_LIFT_ACCESS_RULES_RESPONSE = 'SEARCH_LIFT_ACCESS_RULES_RESPONSE',
  SEARCH_LIFT_ACCESS_RULES_ERROR    = 'SEARCH_LIFT_ACCESS_RULES_ERROR',

  SAVE_LIFT_ACCESS_RULES_REQUEST  = 'SAVE_LIFT_ACCESS_RULES_REQUEST',
  SAVE_LIFT_ACCESS_RULES_RESPONSE = 'SAVE_LIFT_ACCESS_RULES_RESPONSE',
  SAVE_LIFT_ACCESS_RULES_ERROR    = 'SAVE_LIFT_ACCESS_RULES_ERROR',

  BULK_ADD_LIFT_ACCESS_RULES_REQUEST  = 'BULK_ADD_LIFT_ACCESS_RULES_REQUEST',
  BULK_ADD_LIFT_ACCESS_RULES_RESPONSE = 'BULK_ADD_LIFT_ACCESS_RULES_RESPONSE',
  BULK_ADD_LIFT_ACCESS_RULES_ERROR    = 'BULK_ADD_LIFT_ACCESS_RULES_ERROR',

  BULK_ADD_LIFT_ACCESS_RULES_BATCH_PROGRESS = 'BULK_ADD_LIFT_ACCESS_RULES_BATCH_PROGRESS',
  BULK_ADD_LIFT_ACCESS_RULES_BATCH_COMPLETE = 'BULK_ADD_LIFT_ACCESS_RULES_BATCH_COMPLETE',
  BULK_ADD_LIFT_ACCESS_RULES_BATCH_RESET = 'BULK_ADD_LIFT_ACCESS_RULES_BATCH_RESET',
  
  // The delete path: a bulk run sends many contexts, a single rule set delete one.
  BULK_DELETE_LIFT_ACCESS_RULES_REQUEST  = 'BULK_DELETE_LIFT_ACCESS_RULES_REQUEST',
  BULK_DELETE_LIFT_ACCESS_RULES_RESPONSE = 'BULK_DELETE_LIFT_ACCESS_RULES_RESPONSE',
  BULK_DELETE_LIFT_ACCESS_RULES_ERROR    = 'BULK_DELETE_LIFT_ACCESS_RULES_ERROR',

// RESORT PRODUCT MAPPING TOOL

  RESORT_MAPPING_REQUEST         = 'RESORT_MAPPING_REQUEST',
  RESORT_MAPPING_ERROR_REQUESTED = 'RESORT_MAPPING_ERROR_REQUESTED',
  RESORT_MAPPING_RESPONSE        = 'RESORT_MAPPING_RESPONSE',
  RESORT_MAPPING_ERROR           = 'RESORT_MAPPING_ERROR',

  RESORT_MAPPING_ERROR_REQUEST   = 'RESORT_MAPPING_ERROR_REQUEST',
  RESORT_MAPPING_ERROR_RESPONSE  = 'RESORT_MAPPING_ERROR_RESPONSE',
  RESORT_MAPPING_ERROR_ERROR     = 'RESORT_MAPPING_ERROR_ERROR',

  RESORT_MAPPING_HAS_ERROR_REQUEST   = 'RESORT_MAPPING_HAS_ERROR_REQUEST',
  RESORT_MAPPING_HAS_ERROR_RESPONSE  = 'RESORT_MAPPING_HAS_ERROR_RESPONSE',
  RESORT_MAPPING_HAS_ERROR_ERROR     = 'RESORT_MAPPING_HAS_ERROR_ERROR',

  CLEAR_RESORT_MAPPING_ACTION = 'CLEAR_RESORT_MAPPING_ACTION',

  UPDATE_RESORT_MAPPING_REQUEST  = 'UPDATE_RESORT_MAPPING_REQUEST',
  UPDATE_RESORT_MAPPING_RESPONSE = 'UPDATE_RESORT_MAPPING_RESPONSE',
  UPDATE_RESORT_MAPPING_ERROR    = 'UPDATE_RESORT_MAPPING_ERROR',

  UPDATE_PRODUCT_MAPPING_REQUEST = 'UPDATE_PRODUCT_MAPPING_REQUEST',
  UPDATE_PRODUCT_MAPPING_RESPONSE = 'UPDATE_PRODUCT_MAPPING_RESPONSE',
  UPDATE_PRODUCT_MAPPING_ERROR = 'UPDATE_PRODUCT_MAPPING_ERROR',

  UPDATE_PRODUCT_MAPPING_REQUEST_SW = 'UPDATE_PRODUCT_MAPPING_REQUEST_SW',
  UPDATE_PRODUCT_MAPPING_RESPONSE_SW = 'UPDATE_PRODUCT_MAPPING_RESPONSE_SW',
  UPDATE_PRODUCT_MAPPING_ERROR_SW = 'UPDATE_PRODUCT_MAPPING_ERROR_SW',

  UPDATE_RESORT_MAPPING_ROW      = 'UPDATE_RESORT_MAPPING_ROW',
  REVERT_RESORT_MAPPING_ROWS     = 'REVERT_RESORT_MAPPING_ROWS',
  SET_PRODUCT_MAPPING_UNSAVED_EDITS = 'SET_PRODUCT_MAPPING_UNSAVED_EDITS',

  SORT_RESORT_MAPPING_PRODUCTS   = 'SORT_RESORT_MAPPING_PRODUCTS',

  PRODUCT_HYDRATION_ERRORS_REQUEST   = 'PRODUCT_HYDRATION_ERRORS_REQUEST',
  PRODUCT_HYDRATION_ERRORS_RESPONSE  = 'PRODUCT_HYDRATION_ERRORS_RESPONSE',
  PRODUCT_HYDRATION_ERRORS_ERROR     = 'PRODUCT_HYDRATION_ERRORS_ERROR',

  RETRY_PRODUCT_HYDRATION_ERRORS_REQUEST = 'RETRY_PRODUCT_HYDRATION_ERRORS_REQUEST',
  RETRY_PRODUCT_HYDRATION_ERRORS_RESPONSE = 'RETRY_PRODUCT_HYDRATION_ERRORS_RESPONSE',
  RETRY_PRODUCT_HYDRATION_ERRORS_ERROR = 'RETRY_PRODUCT_HYDRATION_ERRORS_ERROR',

  REDEMPTION_HISTORY_REQUEST     = 'REDEMPTION_HISTORY_REQUEST',
  REDEMPTION_HISTORY_RESPONSE    = 'REDEMPTION_HISTORY_RESPONSE',
  REDEMPTION_HISTORY_ERROR       = 'REDEMPTION_HISTORY_ERROR',
  CLEAR_REDEMPTION_HISTORY       = 'CLEAR_REDEMPTION_HISTORY',

  ENTITLEMENT_SHARES_REQUEST     = 'ENTITLEMENT_SHARES_REQUEST',
  ENTITLEMENT_SHARES_RESPONSE    = 'ENTITLEMENT_SHARES_RESPONSE',
  ENTITLEMENT_SHARES_ERROR       = 'ENTITLEMENT_SHARES_ERROR',

  // --- Reports -------------------------------------------------------------------------------------------------------

  GET_GUEST_HYDRATION_ERRORS_REQUEST     = 'GET_GUEST_HYDRATION_ERRORS_REQUEST',
  GET_GUEST_HYDRATION_ERRORS_RESPONSE    = 'GET_GUEST_HYDRATION_ERRORS_RESPONSE',
  GET_GUEST_HYDRATION_ERRORS_ERROR       = 'GET_GUEST_HYDRATION_ERRORS_ERROR',

  GET_GUEST_HYDRATION_ERRORS_COUNT_REQUEST     = 'GET_GUEST_HYDRATION_ERRORS_COUNT_REQUEST',
  GET_GUEST_HYDRATION_ERRORS_COUNT_RESPONSE    = 'GET_GUEST_HYDRATION_ERRORS_COUNT_RESPONSE',
  GET_GUEST_HYDRATION_ERRORS_COUNT_ERROR       = 'GET_GUEST_HYDRATION_ERRORS_COUNT_ERROR',
  CLEAR_GUEST_HYDRATION_ERROR_REPORT           = 'CLEAR_GUEST_HYDRATION_ERROR_REPORT',
  
  REPLAY_GUEST_HYDRATION_ERRORS_REQUEST  = 'REPLAY_GUEST_HYDRATION_ERRORS_REQUEST',
  REPLAY_GUEST_HYDRATION_ERRORS_RESPONSE = 'REPLAY_GUEST_HYDRATION_ERRORS_RESPONSE',
  REPLAY_GUEST_HYDRATION_ERRORS_ERROR    = 'REPLAY_GUEST_HYDRATION_ERRORS_ERROR',

  GET_WEEKLY_VISITOR_DATA_REPORTS_REQUEST   = 'GET_WEEKLY_VISITOR_DATA_REPORTS_REQUEST',
  GET_WEEKLY_VISITOR_DATA_REPORTS_RESPONSE  = 'GET_WEEKLY_VISITOR_DATA_REPORTS_RESPONSE',
  GET_WEEKLY_VISITOR_DATA_REPORTS_ERROR     = 'GET_WEEKLY_VISITOR_DATA_REPORTS_ERROR',
  CLEAR_WEEKLY_VISITOR_DATA_REPORTS         = 'CLEAR_WEEKLY_VISITOR_DATA_REPORTS',

  // ---- User Management ----------------------------------------------------------------------------------------------

  // For getting logged in user info
  GET_USER_REQUEST               = 'GET_USER_REQUEST',
  GET_USER_RESPONSE              = 'GET_USER_RESPONSE',
  GET_USER_ERROR                 = 'GET_USER_ERROR',

  ADD_USER_REQUEST               = 'ADD_USER_REQUEST',
  ADD_USER_RESPONSE              = 'ADD_USER_RESPONSE',
  ADD_USER_ERROR                 = 'ADD_USER_ERROR',

  // For getting list of users by resort
  GET_USERS_REQUEST              = 'GET_USERS_REQUEST',
  GET_USERS_RESPONSE             = 'GET_USERS_RESPONSE',
  GET_USERS_ERROR                = 'GET_USERS_ERROR',

  UPDATE_USER_REQUEST            = 'UPDATE_USER_REQUEST',
  UPDATE_USER_RESPONSE           = 'UPDATE_USER_RESPONSE',
  UPDATE_USER_ERROR              = 'UPDATE_USER_ERROR',

  UPDATE_LAST_RESORT_REQUEST              = 'UPDATE_LAST_RESORT_REQUEST',
  UPDATE_LAST_RESORT_RESPONSE             = 'UPDATE_LAST_RESORT_RESPONSE',
  UPDATE_LAST_RESORT_ERROR                = 'UPDATE_LAST_RESORT_ERROR',

  UPDATE_USER_PREFERENCE_REQUEST      = 'UPDATE_USER_PREFERENCE_REQUEST',
  UPDATE_USER_PREFERENCE_RESPONSE     = 'UPDATE_USER_PREFERENCE_RESPONSE',
  UPDATE_USER_PREFERENCE_ERROR        = 'UPDATE_USER_PREFERENCE_ERROR',

  CHECK_USERNAME_REQUEST         = 'CHECK_USERNAME_REQUEST',
  CHECK_USERNAME_RESPONSE        = 'CHECK_USERNAME_RESPONSE',
  CHECK_USERNAME_ERROR           = 'CHECK_USERNAME_ERROR',

  GET_SUGGESTED_USERNAME_REQUEST  = 'GET_SUGGESTED_USERNAME_REQUEST',
  GET_SUGGESTED_USERNAME_RESPONSE = 'GET_SUGGESTED_USERNAME_RESPONSE',
  GET_SUGGESTED_USERNAME_ERROR    = 'GET_SUGGESTED_USERNAME_ERROR',

  CHECK_EMAIL_REQUEST         = 'CHECK_EMAIL_REQUEST',
  CHECK_EMAIL_RESPONSE        = 'CHECK_EMAIL_RESPONSE',
  CHECK_EMAIL_ERROR           = 'CHECK_EMAIL_ERROR',

  UPDATE_USERNAME_REQUEST        = 'UPDATE_USERNAME_REQUEST',
  UPDATE_USERNAME_RESPONSE       = 'UPDATE_USERNAME_RESPONSE',
  UPDATE_USERNAME_ERROR          = 'UPDATE_USERNAME_ERROR',

  UPDATE_PASSWORD_REQUEST        = 'UPDATE_PASSWORD_REQUEST',
  UPDATE_PASSWORD_RESPONSE       = 'UPDATE_PASSWORD_RESPONSE',
  UPDATE_PASSWORD_ERROR          = 'UPDATE_PASSWORD_ERROR',

  REMOVE_USER_REQUEST            = 'REMOVE_USER_REQUEST',
  REMOVE_USER_RESPONSE           = 'REMOVE_USER_RESPONSE',
  REMOVE_USER_ERROR              = 'REMOVE_USER_ERROR',

  BLOCK_USER_REQUEST             = 'BLOCK_USER_REQUEST',
  BLOCK_USER_RESPONSE            = 'BLOCK_USER_RESPONSE',
  BLOCK_USER_ERROR               = 'BLOCK_USER_ERROR',

  UNBLOCK_USER_REQUEST             = 'UNBLOCK_USER_REQUEST',
  UNBLOCK_USER_RESPONSE            = 'UNBLOCK_USER_RESPONSE',
  UNBLOCK_USER_ERROR               = 'UNBLOCK_USER_ERROR',


  // ---- System Administration ----------------------------------------------------------------------------------------

  UPDATE_CONFIG_REQUEST          = 'UPDATE_CONFIG_REQUEST',
  UPDATE_CONFIG_RESPONSE         = 'UPDATE_CONFIG_RESPONSE',
  UPDATE_CONFIG_ERROR            = 'UPDATE_CONFIG_ERROR',

  // ---- Hotlist ------------------------------------------------------------------------------------------------------

  ADD_TO_HOTLIST_REQUEST         = 'ADD_TO_HOTLIST_REQUEST',
  ADD_TO_HOTLIST_RESPONSE        = 'ADD_TO_HOTLIST_RESPONSE',
  ADD_TO_HOTLIST_ERROR           = 'ADD_TO_HOTLIST_ERROR',

  IS_ON_HOTLIST_REQUEST          = 'IS_ON_HOTLIST_REQUEST',
  IS_ON_HOTLIST_RESPONSE         = 'IS_ON_HOTLIST_RESPONSE',
  IS_ON_HOTLIST_ERROR            = 'IS_ON_HOTLIST_ERROR',

  GET_HOTLIST_REASONS_REQUEST    = 'GET_HOTLIST_REASONS_REQUEST',
  GET_HOTLIST_REASONS_RESPONSE   = 'GET_HOTLIST_REASONS_RESPONSE',
  GET_HOTLIST_REASONS_ERROR      = 'GET_HOTLIST_REASONS_ERROR',

  GET_ENTITLEMENT_HOTLIST_TYPES_REQUEST       = 'GET_ENTITLEMENT_HOTLIST_TYPES_REQUEST',
  GET_ENTITLEMENT_HOTLIST_TYPES_RESPONSE      = 'GET_ENTITLEMENT_HOTLIST_TYPES_RESPONSE',
  GET_ENTITLEMENT_HOTLIST_TYPES_ERROR         = 'GET_ENTITLEMENT_HOTLIST_TYPES_ERROR',

  GET_ENTITLEMENT_HOTLIST_REQUEST             = 'GET_ENTITLEMENT_HOTLIST_REQUEST',
  GET_ENTITLEMENT_HOTLIST_RESPONSE            = 'GET_ENTITLEMENT_HOTLIST_RESPONSE',
  GET_ENTITLEMENT_HOTLIST_ERROR               = 'GET_ENTITLEMENT_HOTLIST_ERROR',

  REMOVE_FROM_ENTITLEMENT_HOTLIST_REQUEST     = 'REMOVE_FROM_ENTITLEMENT_HOTLIST_REQUEST',
  REMOVE_FROM_ENTITLEMENT_HOTLIST_RESPONSE    = 'REMOVE_FROM_ENTITLEMENT_HOTLIST_RESPONSE',
  REMOVE_FROM_ENTITLEMENT_HOTLIST_ERROR       = 'REMOVE_FROM_ENTITLEMENT_HOTLIST_ERROR',

  // ---- FAQs ------------------------------------------------------------------------------------------------------

  LOAD_FAQS_REQUEST              = 'LOAD_FAQS_REQUEST',
  LOAD_FAQS_RESPONSE             = 'LOAD_FAQS_RESPONSE',
  LOAD_FAQS_ERROR                = 'LOAD_FAQS_ERROR',

  UPDATE_RELEASE_FAQ_REQUEST     = 'UPDATE_RELEASE_FAQ_REQUEST',
  UPDATE_RELEASE_FAQ_RESPONSE    = 'UPDATE_RELEASE_FAQ_RESPONSE',
  UPDATE_RELEASE_FAQ_ERROR       = 'UPDATE_RELEASE_FAQ_ERROR',

  CLEAR_FAQS                     = 'CLEAR_FAQS',

  // ---- Release Notes ---------------------------------------------------------------------------------------------

  LOAD_RELEASE_NOTES_REQUEST     = 'LOAD_RELEASE_NOTES_REQUEST',
  LOAD_RELEASE_NOTES_RESPONSE    = 'LOAD_RELEASE_NOTES_RESPONSE',
  LOAD_RELEASE_NOTES_ERROR       = 'LOAD_RELEASE_NOTES_ERROR',

  CLEAR_RELEASE_NOTES            = 'CLEAR_RELEASE_NOTES',

  // ---- Help and Training -----------------------------------------------------------------------------------------

  LOAD_TRAINING_DOCS_REQUEST     = 'LOAD_TRAINING_DOCS_REQUEST',
  LOAD_TRAINING_DOCS_RESPONSE    = 'LOAD_TRAINING_DOCS_RESPONSE',
  LOAD_TRAINING_DOCS_ERROR       = 'LOAD_TRAINING_DOCS_ERROR',

  CLEAR_TRAINING_DOCS            = 'CLEAR_TRAINING_DOCS',

  UPLOAD_TRAINING_DOC_REQUEST    = 'UPLOAD_TRAINING_DOC_REQUEST',
  UPLOAD_TRAINING_DOC_RESPONSE   = 'UPLOAD_TRAINING_DOC_RESPONSE',
  UPLOAD_TRAINING_DOC_ERROR      = 'UPLOAD_TRAINING_DOC_ERROR',

  REPLACE_TRAINING_DOC_REQUEST   = 'REPLACE_TRAINING_DOC_REQUEST',
  REPLACE_TRAINING_DOC_RESPONSE  = 'REPLACE_TRAINING_DOC_RESPONSE',
  REPLACE_TRAINING_DOC_ERROR     = 'REPLACE_TRAINING_DOC_ERROR',

  DELETE_TRAINING_DOC_REQUEST    = 'DELETE_TRAINING_DOC_REQUEST',
  DELETE_TRAINING_DOC_RESPONSE   = 'DELETE_TRAINING_DOC_RESPONSE',
  DELETE_TRAINING_DOC_ERROR      = 'DELETE_TRAINING_DOC_ERROR',
}
